<template>
	<v-layout justify-center class="create">
		<v-flex xs12>
			<v-form v-model="form">
				<input ref="file" type="file" style="display:none;" :multiple="multi" accept="image/png, image/jpeg" @change="handleFileUpload()" />
				<v-container>
					<v-layout row>
						<v-flex v-if="!multi" xs12 md6 offset-md3>
							<v-card>
								<v-text-field v-model="singleTitle" label="Title" class="ml-2 mr-2"></v-text-field>
								<v-card-actions>
									<v-btn @click="clickInput()">
										<v-icon>add_a_photo</v-icon>
									</v-btn>
									<v-btn color="green" :disabled="!isValid" @click="save()">
										<v-icon>cloud_upload</v-icon>
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-flex>
					</v-layout>
					<v-layout v-if="!multi">
						<v-flex xs12 md6 offset-md3>
							<v-card>
								<v-spacer></v-spacer>
								<v-img v-if="sources[0] && sources[0].src" :src="sources[0].src">
									<v-container fill-height fluid pa-2>
										<v-layout fill-height>
											<v-flex xs12 align-end flexbox>
												<span v-if="newCards[0].title" class="headline white--text" v-text="newCards[0].title"></span>
											</v-flex>
										</v-layout>
									</v-container>
								</v-img>
							</v-card>
						</v-flex>
					</v-layout>
					<MultiImageBox v-if="multi" :save-input="save" :is-valid="isValid" :remove="remove" :is-overview="isOverview" :click-input="clickInput" :add="true" />
				</v-container>
			</v-form>
		</v-flex>
	</v-layout>
</template>

<script>
import MultiImageBox from '@/components/MultiImageBox.vue'

String.prototype.hashCode = function() {
	var hash = 0,
		i = 0,
		len = this.length
	while (i < len) {
		hash = ((hash << 5) - hash + this.charCodeAt(i++)) << 0
	}
	return hash
}
String.prototype.hashcode = function() {
	return this.hashCode() + 2147483647 + 1
}
export default {
	name: 'Create',
	components: {
		MultiImageBox
	},
	props: {
		resetAdd: {
			type: Function,
			required: true
		},
		multi: {
			type: Boolean,
			required: true
		},
		isOverview: {
			type: Boolean,
			required: true
		}
	},
	data: () => ({
		newCards: [],
		isValid: false,
		form: false,
		sources: [],
		singleTitle: null
	}),
	computed: {
		title() {
			var card = this.$store.state.cards.filter(card => {
				return card.link == this.$route.path
			})
			return card[0].title
		},
		storeSourcesLoaded() {
			return this.$store.state.storeSourcesLoaded
		}
	},
	watch: {
		sources: function() {
			this.isValid = this.newCards.length > 0 && ((this.singleTitle && !this.multi) || this.multi)
			this.$store.commit('setSources', this.sources)
		},
		singleTitle: function(value) {
			if (this.newCards.length > 0) {
				this.newCards[0].title = value
			}
			this.isValid = this.newCards.length > 0 && ((this.singleTitle && !this.multi) || this.multi)
		}
	},
	methods: {
		clickInput() {
			this.$refs.file.click()
		},
		resetSources() {
			if (this.storeSourcesLoaded) {
				console.log(this.storeSourcesLoaded)
				setTimeout(() => {
					this.resetAdd()
					this.$store.commit('setSources', [])
				}, 500)
			}
		},
		checkAllSaved() {
			if (this.$route.params.id) {
				this.$store.dispatch('getVacation', this.$route.params.id).then(() => {
					this.resetSources()
				})
			} else {
				this.$store.dispatch('getVacations').then(() => {
					this.resetSources()
				})
			}
		},
		remove(id) {
			this.sources = this.sources.filter(source => {
				return source.id !== id
			})
			this.newCards = this.newCards.filter(source => {
				return source.id !== id
			})
		},
		setFileSrc(i) {
			let reader = new FileReader()
			reader.addEventListener(
				'load',
				function() {
					var id = new Date().getTime() + ''.hashcode()
					this.sources.push({
						idx: i,
						id: id,
						loaded: 0,
						src: reader.result,
						isNew: true
					})
					this.newCards[i].id = id
				}.bind(this, i),
				false
			)

			if (this.newCards[i].file) {
				if (/\.(jpe?g|png|gif)$/i.test(this.newCards[i].file.name)) {
					reader.readAsDataURL(this.newCards[i].file)
				}
			}
		},
		handleFileUpload() {
			this.sources = []
			for (var i = 0; i < this.$refs.file.files.length; i++) {
				this.newCards[i] = {
					title: this.multi ? this.title : this.singleTitle,
					isSpecific: this.$route.params.id ? true : false,
					src: null,
					file: this.$refs.file.files[i]
				}
				this.setFileSrc(i)
			}
		},
		save() {
			this.newCards.forEach(card => {
				this.$store.dispatch('save', card).then(() => {
					this.checkAllSaved()
				})
			})
		}
	}
}
</script>
